var _style, _path, _defs, _defs2, _g, _defs3, _defs4, _g2, _defs5, _polyline, _defs6, _path2, _defs7, _polyline2, _defs8, _polyline3, _defs9, _path3, _defs0, _polyline4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyMyPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "159px",
    height: "158px",
    viewBox: "0 0 159 158",
    style: {
      enableBackground: "new 0 0 159 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1F2F3;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{clip-path:url(#SVGID_4_);}\n\t.st3{clip-path:url(#SVGID_6_);}\n\t.st4{clip-path:url(#SVGID_8_);}\n\t.st5{clip-path:url(#SVGID_10_);fill:#F9CD74;}\n\t.st6{clip-path:url(#SVGID_12_);fill:#F9B659;}\n\t.st7{clip-path:url(#SVGID_14_);fill:#F1F2F3;}\n\t.st8{clip-path:url(#SVGID_16_);fill:#656D78;}\n\t.st9{clip-path:url(#SVGID_18_);fill:#EB9850;}\n\t.st10{clip-path:url(#SVGID_20_);fill:#3E444E;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.1,0C47.9,0,20.9,18.1,8,44.4l37.9,19.5v-1.4l0,0l14.6-6.7l-2.3-1.1l8-3.7l2.3,1.1l12.2-5.6l34.7,16 c0,0,0,0-0.1,0.1l0.2-0.1v43.2l-34.8,16l0,0l-33.9-15.6l0,0l-0.4-0.2l-0.4-0.2l0,0l-45.9-26C0.5,123,35.7,158,79.1,158 c43.7,0,79.1-35.4,79.1-79S122.8,0,79.1,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_1_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M-8.2,36L-8.2,36l-39.6,16.6l48,27.1c0-0.2,0-0.5,0-0.7l0,0l0,0c0-12.4,2.9-24.2,8-34.6L-8.2,36"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_5_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M46.4,105.9l0.4,0.2l0,0L46.4,105.9 M8,44.4C2.9,54.8,0,66.6,0,79c0,0.2,0,0.5,0,0.7l45.9,25.9 V63.9L8,44.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.980232e-08 0)",
    className: "st4"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_9_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "45.9,62.5 45.9,63.9 45.9,105.7 45.9,105.7 46.4,105.9 46.8,106.1 80.7,121.7 80.7,121.7  80.7,78.5 80.7,78.5 80.7,78.5 80.7,78.5 45.9,62.5 45.9,62.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_11_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.5,55.8l-14.6,6.7l34.8,16l0,0L94.9,72L60.5,55.8 M80.7,46.5l-12.2,5.6l34.2,16.3l12.6-5.8 c0,0,0,0,0.1-0.1L80.7,46.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_13_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "66.2,51 66.2,51 58.2,54.7 60.5,55.8 68.6,52.1 66.2,51  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_15_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "68.6,52.1 60.5,55.8 94.9,72 102.8,68.4 68.6,52.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_17_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.9,68.4L102.9,68.4v22.9l-3.1-0.1L95,95.1V72L102.9,68.4 M115.5,62.5l-0.2,0.1l-12.6,5.8L94.9,72 l-14.2,6.5v43.2l34.8-16V62.5"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_19_",
    points: "-47.9,36 115.5,36 115.5,121.7 -47.9,121.7 -47.9,36  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "102.9,68.4 95,72 95,95.1 99.8,91.2 102.8,91.3 102.9,68.4  "
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMyPerformance);
export default __webpack_public_path__ + "static/media/empty-my-performance.f64c89e0e8131e7907d489a9d339ef43.svg";
export { ForwardRef as ReactComponent };